// extracted by mini-css-extract-plugin
export default {"link":"active-link_link__MWbQF"};